import { displayTitle } from './tutorial'
import type { TutorialHit } from './types'

const nonEmpty = (s: unknown): s is string => typeof s === 'string' && s.length > 0

/** Best available thumbnail for a list/grid tile. */
export function hitImage(hit: TutorialHit): string | undefined {
  if (nonEmpty(hit.thumbnail_image)) return hit.thumbnail_image
  if (nonEmpty(hit.hero_image)) return hit.hero_image
  if (nonEmpty(hit.youtube_maxres)) return hit.youtube_maxres
  if (hit.hero_image === undefined && Array.isArray(hit.images)) {
    // v1 had `i.type = 'hero'` (an assignment), which always picked the first image.
    return (hit.images.find((i) => i.type === 'hero') ?? hit.images[0])?.url || undefined
  }
  return undefined
}

/** Site-relative link to the tutorial page. Legacy records only carry an absolute url. */
export function hitPath(hit: TutorialHit): string {
  if (hit.slug) return `/tutorial/${hit.slug}`
  const legacy = hit.url?.split('.com')[1]
  return legacy || '/tutorials'
}

/** Raw (possibly HTML-encoded) title without a trailing "(…)" note. */
export function hitTitle(hit: TutorialHit): string {
  return displayTitle(hit.title || hit.name || '')
}

export function hitKey(hit: TutorialHit, fallback: number): string | number {
  return hit.objectID ?? hit.id ?? fallback
}
